<script>
import api from './api'
export default {
  load (id) {
    return api.getData('users/' + id)
  },
  save (id, formData) {
    if (!id) {
      return api.post('users', formData)
    }
    return api.put('users/' + id, formData)
  },
  remove (id) {
    return api.delete('users/' + id)
  },
  list (params) {
    return api.get('users', params)
  },
  toggleAccess (id) {
    return api.put('users/' + id + '/toggleaccess')
  }
}
</script>



// WEBPACK FOOTER //
// user.vue?2709ebd0